import { BaseAuthenticatedView } from '@/views/authenticated';

import profileRoutes from './profile/profile';
import adminRoutes from './admin/admin';

export default [
  {
    name: 'app_base_authenticated',
    component: BaseAuthenticatedView,
    meta: { requiresAuthentication: true },
    children: [
      ...adminRoutes,
      ...profileRoutes,
    ],
  },
];
